import { useQuery } from '@tanstack/react-query';
import { ping, getVirtualPrice } from './services';

export const usePing = () =>
  useQuery({
    queryKey: ['ping'],
    queryFn: () => ping(),
  });

export const useGetCoinData = () =>
  useQuery({
    queryKey: ['getCoinData'],
    queryFn: () => getVirtualPrice(),
  });
